import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7fghelgl: FaireBrandEntity = {
  token: "b_7fghelgl",
  type: "brand",
  name: "Viverano Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/32b0f33f1affb21a3d55abf64ae1649c4666018a7f15c18ec789795b6b182618.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/36951e71427c04d98a88e736ff2ad9b05f8ba45dd5db4fd4f44b222a33c31461.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/32b0f33f1affb21a3d55abf64ae1649c4666018a7f15c18ec789795b6b182618.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/36951e71427c04d98a88e736ff2ad9b05f8ba45dd5db4fd4f44b222a33c31461.jpeg",
  location: "Las Vegas, NV, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 251,
  isTopShop: true,
  isInsider: true,
  description:
    'Organic. Whimsical. Happy.\n\nAt Viverano Organics, we believe childhood is a magical adventure—one filled with wonder, laughter, and tiny moments that mean everything. Since 2013, we’ve been weaving joy into every stitch, creating soft, organic baby clothing that’s as gentle on the planet as it is on delicate skin.\n\nOur name, Viverano, is a blend of vivere—"to live"—and verano, the warmth of summer. It’s a celebration of life’s little joys, the golden glow of childhood, and the beauty of simplicity.\n\nInspired by heirloom craftsmanship and playful charm, our designs are thoughtfully created for little explorers. Delicate embroidery, charming appliqués, and timeless solid knits come together in soft, breathable organic cotton—because babies deserve nothing less than pure comfort and style.\n\nEach piece is crafted sustainably in India, where skilled artisans bring our vision to life with care and integrity. From the cotton fields to your little one’s wardrobe, we ensure every step of our process respects the Earth and the hands that make it.\n\nWe believe in creating clothing with purpose and love. Our organic fabrics are free from harsh chemicals, and our commitment to ethical production ensures fair treatment for the people behind every thread.\n\nPure organic cotton. Whimsical charm. Soulful. Timeless joy. That’s the Viverano way.\n\nWelcome to our world. Let’s make happy memories, one loving stitch at a time.',
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:58:25.379Z",
    importedBy: "entity-db-cli",
  },
};
